import axios from "@/axios";

// ===== 구독 상태 =====
export const ResellerSubscriptionStatus = {
  CONTRACT: "CONTRACT",
  SETUP: "SETUP",
  INSPECTION: "INSPECTION",
  ACTIVE: "ACTIVE",
  SUSPENDED: "SUSPENDED",
  TERMINATED: "TERMINATED",
};

// ===== 결제 주기 =====
export const PaymentCycle = {
  MONTHLY: "MONTHLY",
  YEARLY: "YEARLY",
  ONCE: "ONCE",
};

// ===== 결제 상태 =====
export const PaymentStatus = {
  PENDING: "PENDING",
  COMPLETED: "COMPLETED",
  FAILED: "FAILED",
  REFUNDED: "REFUNDED",
  PARTIAL_REFUNDED: "PARTIAL_REFUNDED",
  CANCELED: "CANCELED",
};

// ===== 할인 타입 =====
export const DiscountType = {
  PERCENTAGE: "PERCENTAGE",
  FIXED: "FIXED",
};

// ===== 구독 결제 상태 (미납 관리용) =====
export const SubscriptionPaymentStatus = {
  NORMAL: "NORMAL",
  OVERDUE: "OVERDUE",
};

// ===== 리셀러 구독 API (관리자용) =====
export const resellerSubscriptionApi = {
  // 구독 목록 조회
  async getList(params = {}) {
    const searchParams = {
      page: params.page || 1,
      limit: params.limit || 10,
      ...(params.companyId && { companyId: params.companyId }),
      ...(params.companyName && { companyName: params.companyName }),
      ...(params.packageName && { packageName: params.packageName }),
      ...(params.status && { status: params.status }),
      ...(params.paymentCycle && { paymentCycle: params.paymentCycle }),
      ...(params.paymentStatus && { paymentStatus: params.paymentStatus }),
    };
    const response = await axios.post(
      "/admin/reseller-subscriptions",
      searchParams
    );
    return response.data;
  },

  // 구독 상세 조회
  async getDetail(id) {
    const response = await axios.get(`/admin/reseller-subscriptions/${id}`);
    return response.data;
  },

  // 구독 생성
  async create(data) {
    const response = await axios.post(
      "/admin/reseller-subscriptions/create",
      data
    );
    return response.data;
  },

  // 구독 수정
  async update(id, data) {
    const response = await axios.put(
      `/admin/reseller-subscriptions/${id}`,
      data
    );
    return response.data;
  },

  // 구독 삭제
  async delete(id) {
    const response = await axios.delete(`/admin/reseller-subscriptions/${id}`);
    return response.data;
  },

  // 구독 상태 변경
  async changeStatus(id, status, reason) {
    const response = await axios.put(
      `/admin/reseller-subscriptions/${id}/status`,
      {
        status,
        reason,
      }
    );
    return response.data;
  },

  // 회사별 구독 목록 조회
  async getByCompany(companyId) {
    const response = await axios.get(
      `/admin/reseller-subscriptions/company/${companyId}`
    );
    return response.data;
  },

  // 수동 결제 처리
  async processPayment(id) {
    const response = await axios.post(
      `/admin/reseller-subscriptions/${id}/process-payment`
    );
    return response.data;
  },

  // 결제 현황 조회
  async getPaymentStatus(id) {
    const response = await axios.get(
      `/admin/reseller-subscriptions/${id}/payment-status`
    );
    return response.data;
  },

  // 설치비 결제 처리
  async processInstallationFeePayment(id) {
    const response = await axios.post(
      `/admin/reseller-subscriptions/${id}/process-installation-fee`
    );
    return response.data;
  },
};

// ===== 리셀러 회사 카드 API (관리자용) =====
export const resellerCompanyCardApi = {
  // 회사의 카드 목록 조회
  async getByCompany(companyId) {
    const response = await axios.get(
      `/admin/reseller-company-cards/company/${companyId}`
    );
    return response.data;
  },

  // 카드 유효성 검사
  async validate(data) {
    const response = await axios.post(
      "/admin/reseller-company-cards/validate",
      data
    );
    return response.data;
  },

  // 카드 등록
  async register(data) {
    const response = await axios.post(
      "/admin/reseller-company-cards/register",
      data
    );
    return response.data;
  },

  // 카드 삭제
  async delete(id) {
    const response = await axios.delete(`/admin/reseller-company-cards/${id}`);
    return response.data;
  },

  // 기본 카드 설정
  async setDefault(id) {
    const response = await axios.put(
      `/admin/reseller-company-cards/${id}/default`
    );
    return response.data;
  },
};

// ===== 리셀러 결제 이력 API (관리자용) =====
export const resellerPaymentHistoryApi = {
  // 결제 이력 목록 조회
  async getList(params = {}) {
    const searchParams = {
      page: params.page || 1,
      limit: params.limit || 10,
      ...(params.subscriptionId && { subscriptionId: params.subscriptionId }),
      ...(params.companyId && { companyId: params.companyId }),
      ...(params.companyName && { companyName: params.companyName }),
      ...(params.productName && { productName: params.productName }),
      ...(params.resellerId && { resellerId: params.resellerId }),
      ...(params.status && { status: params.status }),
      ...(params.dateType && { dateType: params.dateType }),
      ...(params.startDate && { startDate: params.startDate }),
      ...(params.endDate && { endDate: params.endDate }),
      ...(params.sortBy && { sortBy: params.sortBy }),
      ...(params.sortOrder && { sortOrder: params.sortOrder }),
    };
    const response = await axios.post(
      "/admin/reseller-payment-histories",
      searchParams
    );
    return response.data;
  },

  // 구독별 결제 이력 조회
  async getBySubscription(subscriptionId) {
    const response = await axios.get(
      `/admin/reseller-payment-histories/subscription/${subscriptionId}`
    );
    return response.data;
  },

  // 회사별 결제 이력 조회
  async getByCompany(companyId, limit) {
    const url = limit
      ? `/admin/reseller-payment-histories/company/${companyId}?limit=${limit}`
      : `/admin/reseller-payment-histories/company/${companyId}`;
    const response = await axios.get(url);
    return response.data;
  },

  // 결제 통계 조회 (params: resellerId, dateType, startDate, endDate, companyName, productName, companyId)
  async getStats(params = {}) {
    const response = await axios.get(
      "/admin/reseller-payment-histories/stats/summary",
      { params }
    );
    return response.data;
  },

  // 리셀러 선택 목록: 삭제되지 않은 RESELLER 회사, 업체명순 (최대 1,000개)
  async getResellerOptions() {
    const response = await axios.post("/companies/list/v2", {
      type: "RESELLER",
      deleteYn: "N",
      page: 1,
      limit: 1000,
    });
    return (response.data.docs || [])
      .map((c) => ({ value: c._id, label: c.name }))
      .sort((a, b) => (a.label || "").localeCompare(b.label || "", "ko"));
  },

  // 결제 취소
  async cancelPayment(id, cancelReason, cancelAmount) {
    const response = await axios.put(
      `/admin/reseller-payment-histories/${id}/cancel`,
      {
        cancelReason,
        ...(cancelAmount !== undefined && { cancelAmount }),
      }
    );
    return response.data;
  },
};

// ===== 거래처 (고객) API =====
export const resellerCustomerApi = {
  // 고객 목록 조회 (병원/제조사 전체)
  async getList(params = {}) {
    const response = await axios.post("/companies/reseller/customers", {
      page: params.page || 1,
      limit: params.limit || 100,
      ...(params.type && { type: params.type }),
      ...(params.search && { search: params.search }),
      ...(params.addrOne && { addrOne: params.addrOne }),
      ...(params.addrTwo && { addrTwo: params.addrTwo }),
    });
    return response.data;
  },

  // 고객 상세 조회
  async getDetail(customerId) {
    const response = await axios.get(
      `/companies/reseller/customers/${customerId}`
    );
    return response.data;
  },
};

// ===== 구독 상품 API =====
export const subscriptionPackageApi = {
  // 구독 상품 목록 조회
  async getAll(params = {}) {
    const response = await axios.get("/subscription-packages", { params });
    return response.data;
  },

  // 구독 상품 상세 조회
  async getById(id) {
    const response = await axios.get(`/subscription-packages/${id}`);
    return response.data;
  },
};

export default {
  resellerSubscriptionApi,
  resellerCompanyCardApi,
  resellerPaymentHistoryApi,
  resellerCustomerApi,
  subscriptionPackageApi,
};
